import React, { useEffect } from 'react'
import { MapContainer, TileLayer, useMap } from 'react-leaflet'
import 'leaflet/dist/leaflet.css'
import MarkersMultiple from './MarkersMultiple'
import config from '../../../../config.json'

// 🔹 Componente auxiliar para cambiar el centro después de montar
function ChangeView({ center, zoom }) {
    const map = useMap()
    useEffect(() => {
        if (center) {
            map.setView(center, zoom)
            // map.flyTo(center, zoom) // si quieres animación
        }
    }, [center, zoom, map])
    return null
}

export default function MapView({ clients = [], scroll = true }) {

    // 🔹 Buscar la primera geolocalización válida entre los subs
    const firstGeo = clients.flatMap(c => c.subs)
        .find(sub => sub.geolocalizacion && sub.geolocalizacion.trim() !== '' && sub.geolocalizacion.includes(','))?.geolocalizacion

    const center = (firstGeo && firstGeo.split(',').length === 2)
        ? {
            lat: parseFloat(firstGeo.split(',')[0]),
            lng: parseFloat(firstGeo.split(',')[1])
        }
        : {
            lat: parseFloat(config.lat),
            lng: parseFloat(config.long)
        }

    return (
        <MapContainer
            center={center}
            zoom={13}
            scrollWheelZoom={scroll}
            style={{ height: "500px", width: "100%" }}
        >
            <TileLayer
                url="https://tile.openstreetmap.org/{z}/{x}/{y}.png"
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
            />
            <ChangeView center={center} zoom={13} />

            {/* 🔹 Pasar todos los subs al componente de marcadores */}
            <MarkersMultiple clients={clients} />
        </MapContainer>
    )
}
